"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACountableBalances = exports.AccountBalanceTypeEnum = void 0;
/** Типы счётов */
var AccountBalanceTypeEnum;
(function (AccountBalanceTypeEnum) {
  /**
   * Основной
   *
   * @deprecated Счёт был переименован в paid, чтобы лучше отображать логику
   * @see AccountBalanceTypeEnum.paid
   */
  AccountBalanceTypeEnum[AccountBalanceTypeEnum["primary"] = 1] = "primary";
  /**
   * Приобретено
   * Аналитический счёт для учёта средств, полученных в результате покупки за реальные деньги
   */
  AccountBalanceTypeEnum[AccountBalanceTypeEnum["paid"] = 1] = "paid";
  /**
   * Заблокировано
   * Счёт для блокировок (например, при оплате)
   *
   * @deprecated Используйте hold, потому что это не блокировка, а приостановка денежных средств.
   * @see AccountBalanceTypeEnum.hold
   */
  AccountBalanceTypeEnum[AccountBalanceTypeEnum["block"] = 2] = "block";
  /**
   * Ожидает
   * Аналитический счёт для учёта средств, находящихся в ожидании (отложенные операции)
   */
  AccountBalanceTypeEnum[AccountBalanceTypeEnum["hold"] = 2] = "hold";
  /**
   * Комиссия Onclass
   * Аналитический счёт для учёта комиссии onclass
   *
   * @deprecated
   */
  AccountBalanceTypeEnum[AccountBalanceTypeEnum["onclass_fee"] = 3] = "onclass_fee";
  /**
   * Штрафы
   * Аналитический счёт для учёта штрафов
   *
   * @deprecated
   */
  AccountBalanceTypeEnum[AccountBalanceTypeEnum["fine"] = 4] = "fine";
  /**
   * Комиссия за процессинг
   * Аналитический счёт для учёта сборов за транзакции
   *
   * @deprecated
   */
  AccountBalanceTypeEnum[AccountBalanceTypeEnum["transaction_fee"] = 5] = "transaction_fee";
  /**
   * По купонам
   * Аналитический счёт для учёта средств, полученных через активацию купонов
   */
  AccountBalanceTypeEnum[AccountBalanceTypeEnum["coupons"] = 7] = "coupons";
  /**
   * Подарок
   * Аналитический счёт для учёта средств, полученных в виде подарка
   */
  AccountBalanceTypeEnum[AccountBalanceTypeEnum["gifts"] = 8] = "gifts";
  /**
   * По тарифу
   * Аналитический счёт для учёта средств, полученных при активации или продлении тарифного плана
   */
  AccountBalanceTypeEnum[AccountBalanceTypeEnum["plan_grants"] = 9] = "plan_grants";
  /**
   * За митинги
   * Аналитический счёт для учёта средств, потраченных на митинги
   */
  AccountBalanceTypeEnum[AccountBalanceTypeEnum["meetings"] = 10] = "meetings";
  /**
   * Вознаграждение
   * Аналитический счёт для учёта средств, полученных в виде вознаграждения
   */
  AccountBalanceTypeEnum[AccountBalanceTypeEnum["reward"] = 11] = "reward";
})(AccountBalanceTypeEnum = exports.AccountBalanceTypeEnum || (exports.AccountBalanceTypeEnum = {}));
exports.ACountableBalances = [AccountBalanceTypeEnum.paid, AccountBalanceTypeEnum.gifts, AccountBalanceTypeEnum.coupons, AccountBalanceTypeEnum.plan_grants, AccountBalanceTypeEnum.reward];
